/*
 * @Description: 基础配置文件
 * @Author: yingbin
 * @Date: 2019-09-06 16:23:22
 * @LastEditTime: 2019-09-09 13:27:52
 * @LastEditors: yingbin
 */
function industry() {
    return [
        "服装类",
        "电子类",
        "软件供应商",
        "食品类",
        "百货类",
        "汽配类",
        "加点零售",
        "医药及医疗器材",
        "金融类",
        "电商类",
        "旅游休闲",
        "政府机构",
        "其他"
    ]
}

module.exports = {
    industry: industry()
}